import { JSX } from "react"
import { NavigateFunction, useNavigate } from "react-router"

import Button from "../../Component/Button"
import Sprite from "../../Component/Sprite"
import { useBodyClassName } from "../../Context/BodyClassNameContext"
import { randomNumberGenerator } from "../../Service"

import "./main-menu.css"

export default function MainMenuPage(): JSX.Element {
  const navigate: NavigateFunction = useNavigate()
  useBodyClassName("main-menu")

  const startNewGame: () => void = (): void => {
    navigate(`/play/${randomNumberGenerator.randomString(10)}`)
  }

  const daily: () => void = (): void => {
    navigate(`/daily`)
  }

  return (
    <>
      <Sprite type="soldier" sprite="fighting" />
      <Sprite type="orc" sprite="fighting" />
      <Button onClick={startNewGame}>New Game</Button>
      <Button onClick={daily}>Play daily</Button>
    </>
  )
}
